<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
// import devPixelRatio from "@/utils/devicePixelRatio.js";
export default {
  data() {
    return {
      activeIndex: 0,
      isShow: true,
      fixed: true,
      isRouterAlive: true,
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  // created() {
  //   new devPixelRatio().init(); // 初始化页面比例
  // },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  overflow: auto !important;
  /* background: #eee;
  opacity: 0.1; */
}

@media (min-width: 1881px) {
  html {
    font-size: 10px !important;
  }
}

@media only screen and (min-width: 1721px) and (max-width: 1880px) {
  html {
    font-size: 9.15px !important;
  }
}

@media only screen and (min-width: 1521px) and (max-width: 1720px) {
  html {
    font-size: 8px !important;
  }
}

@media only screen and (min-width: 1321px) and (max-width: 1520px) {
  html {
    font-size: 7.1px !important;
  }
}

@media only screen and (min-width: 1161px) and (max-width: 1320px) {
  html {
    font-size: 6.35px !important;
  }
}

@media only screen and (min-width: 1024px) and (max-width: 1160px) {
  html {
    font-size: 5.55px !important;
  }
}

.el-table::before {
  width: 0 !important;
}

.el-table--border::after,
.el-table--group::after {
  width: 0 !important;
}

.el-table .cell {
  text-align: left;
}

.navbar {
  display: flex;
  justify-content: space-between;
}

.nav-left {
  display: flex;
}

/* 页面公用样式 */
.head-title {
  font-weight: 500;
  color: #333;
  height: 3.3rem;
  line-height: 3.3rem;
  font-size: 2.4rem;
  margin-bottom: 1.5rem;
}



.help-danger {
  color: red;
}

.help .help-link {

  border: .1rem solid #49B372;
  padding: 1rem 1.2rem;
  font-size: 1.4rem;
  font-weight: 400;
  color: #49B372;
  line-height: 2rem;
  /* position: relative;
  right: -48.5rem;
  top: 1rem; */
  border-radius: .8rem;
  float: right;
}

.helpLink {
  color: #66b1ff;
}

.help-bold {
  margin-bottom: 0px;
  font-weight: 700;
}

.mMain {
  padding: 2.8rem 3rem 2rem;
  background: #FFFFFF;
  border-radius: .8rem;

}

/* 详情页顶部 */
.page-header {
  margin-bottom: 1.2rem;
}

.el-page-header__left {
  padding: 1rem 2.6rem;
  border-radius: 0.8rem;
  font-size: 1.4rem;
  line-height: 2rem;
  margin-right: 2rem !important;

  height: 4rem;
  background: #FFFFFF;
  border-radius: .8rem;
  border: .1rem solid #E6E6E6;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;


}

.el-page-header__left::after {
  display: none;
}

.el-page-header__content {
  line-height: 4rem;
  font-size: 2.4rem !important;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333 !important;
}

::-webkit-scrollbar-track-piece {
  -webkit-border-radius: 0;
}

::-webkit-scrollbar {
  width: .5rem;
  height: 1rem;
}

::-webkit-scrollbar-thumb {
  height: 5rem;
  background-color: #fff;
  -webkit-border-radius: .6rem;
  outline-offset: -.2rem;
  filter: alpha(opacity=50);
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  opacity: 0.5;
}

::-webkit-scrollbar-thumb:hover {
  height: 5rem;
  background-color: #878987;
  -webkit-border-radius: .6rem;
}
</style>
<style lang="scss">
/* element-ui对话框 */
.el-dialog__header {
  background-color: #fff !important;

  .el-dialog__title,
  .el-dialog__headerbtn .el-dialog__close {
    font-size: 2.4rem !important;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #141B2D !important;
    line-height: 3.3rem;
  }
}

.el-button--primary {
  color: #fff !important;
  background: #49B372 !important;
  border-radius: .8rem;
  border: none !important;
}




/* 表格头部,表格斑马线,加深表格选中效果 */
.el-table .success-row {
  background: #f9f9f9;
}

.el-table .warning-row {
  background: #ffffff;
}

.el-table thead th {
  background-color: #eee;
  color: #19273c;
  font-weight: 400;
  padding: 1.1rem 0;
}

.el-table--border {
  border: none !important;
}

.el-table--border td,
.el-table--border th {
  border: none !important;
}

.el-button {
  padding: 1.3rem 2rem !important;
  //height: 4rem;
}

// element-ui图片预览遮罩层
#app .el-image-viewer__mask {
  opacity: 0.8;
}

#app .el-image-viewer__close {
  top: 7rem;
  color: #e2e2e2;
}

// ...自定义样式修改
.set-popper {
  width: 50rem;
}

.set-content {
  cursor: default;
  width: 100%;
  overflow: hidden;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
<style lang="scss">
//帮助文档样式
.el-collapse-item__header {
  padding: 2rem 2rem 1.5rem;
  font-size: 1.8rem !important;
  line-height: 2.5rem;
  border-bottom: none;
  background-color: #fef7ec !important;
}

.el-collapse-item__arrow {
  margin: 0 0 0 auto;
}

.el-collapse {
  border: none !important;
}

.el-collapse-item__content {
  background-color: #f8f8f8 !important;
  padding-bottom: 0 !important;
}

.el-collapse-item__wrap,
.el-collapse-item__header {
  border-bottom: 0 !important;
}

.help {
  border-radius: 0 0 1rem 1rem;
  padding: 0 2rem 4rem;
  height: auto;
  font-size: 1.4rem;
  font-weight: 400;
  color: #FF9E58;
  line-height: 1.8rem;
  background: #fef7ec !important;

  p {
    margin-bottom: 1.8rem;
  }

  p:last-child {
    margin-bottom: 0;
  }
}

//table样式
th {
  font-size: 1.6rem !important;

}

.el-table thead th {
  background-color: #fff;
}

.el-table--enable-row-transition .el-table__body td {
  border-top: 1px solid #EBEEF5 !important;
}

.el-table__fixed-right::before, .el-table__fixed::before {
  height: 0 !important;
}

.el-table {
  margin-top: 2rem !important;
}

.abc,
.bac {
  background: #fff !important;
  border-radius: .8rem;
  border: 1px solid #E6E6E6;
  padding: 2rem 2rem 0;
}

//分页器样式
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #49B372 !important;
}

//按钮统一样式

.el-button--danger {
  color: #F00000 !important;
  background: #fff !important;
  border: 1px solid #F00000 !important;
}

.el-button--danger:hover {
  color: #F00000 !important;
}

.el-switch.is-checked .el-switch__core {
  border-color: #49B372 !important;
  background-color: #49B372 !important;
}

.el-button--text {
  color: #49B372;
  font-size: 1.6rem !important;
  padding-right: 4rem !important;
  padding-left: 0px !important;
}

.el-dialog .dialog-footer .el-button--primary {
  margin-left: 5rem !important;
}

.el-upload-list__item-name {
  display: block !important;
}

.el-dialog .el-table thead th {
  background: #F8F8F8;
}

.el-button--default:hover {
  color: #333 !important;
  background: #fff !important;
  border: 1px solid #DCDFE6 !important;
}

.el-button--primary:hover {
  color: #fff !important;
  background: #49B372 !important;
  border: 0 !important;
}

/*取消按钮样式 */

.el-button--default:focus,
.el-button--default:hover {
  color: #49B372;
  border-color: #49B372;
  background-color: #F6FFFA;
}</style>

